import type {NotificationUsersActions} from 'src/action-creators/referral-v2/referral-notification-user';
import type {GenericError, NotificationUsers} from 'src/types/referral-v2';

import {
  NOTIFICATION_USERS_LOADING,
  NOTIFICATION_USERS,
  NOTIFICATION_USERS_ERROR,
  NOTIFICATION_CONFIG_USERS_LOADING,
  NOTIFICATION_CONFIG_USERS,
  NOTIFICATION_CONFIG_USERS_ERROR,
} from 'src/action-creators/referral-v2/referral-notification-user';


export const ReferralCurrentState = {
  IDLE: 'idle',
  FETCHING_NOTIFICATION_USER: 'fetchingNotificationUsers',
  FETCHING_NOTIFICATION_CONFIG_USER: 'fetchingNotificationConfigUsers',
} as const;

export type ReferralNotificationUsersState = {
  current_state: string;
  notification_config_users: NotificationUsers[] | null | undefined;
  notification_config_users_error: GenericError | null | undefined;
  notification_users: NotificationUsers[] | null | undefined;
  notification_users_error: GenericError | null | undefined;
};

const initialState = {
  notification_users: null,
  notification_users_error: null,
  current_state: '',
  notification_config_users: null,
  notification_config_users_error: null,
} as const;

export default (
  state: ReferralNotificationUsersState | null | undefined = initialState,
  action: NotificationUsersActions,
): ReferralNotificationUsersState => {
  switch (action.type) {
    case NOTIFICATION_USERS_LOADING:
      // @ts-expect-error - TS2322 - Type '{ current_state: "fetchingNotificationUsers"; notification_config_users?: NotificationUsers[] | null | undefined; notification_config_users_error?: GenericError | null | undefined; notification_users?: NotificationUsers[] | null | undefined; notification_users_error?: GenericError | null | undefined; }' is not assignable to type 'ReferralNotificationUsersState'.
      return {
        ...state,
        current_state: ReferralCurrentState.FETCHING_NOTIFICATION_USER,
      };
    case NOTIFICATION_USERS:
      // @ts-expect-error - TS2322 - Type '{ notification_users_error: null; notification_users: NotificationUsers[] | null | undefined; current_state?: string | undefined; notification_config_users?: NotificationUsers[] | null | undefined; notification_config_users_error?: GenericError | null | undefined; }' is not assignable to type 'ReferralNotificationUsersState'.
      return {
        ...state,
        notification_users_error: null,
        notification_users: action.payload,
      };
    case NOTIFICATION_USERS_ERROR:
      // @ts-expect-error - TS2322 - Type '{ notification_users_error: GenericError | null | undefined; current_state?: string | undefined; notification_config_users?: NotificationUsers[] | null | undefined; notification_config_users_error?: GenericError | null | undefined; notification_users?: NotificationUsers[] | null | undefined; }' is not assignable to type 'ReferralNotificationUsersState'.
      return {
        ...state,
        notification_users_error: action.payload,
      };

    case NOTIFICATION_CONFIG_USERS: {
      // @ts-expect-error - TS2322 - Type '{ notification_config_users: NotificationUsers[] | null | undefined; current_state: "idle"; notification_config_users_error?: GenericError | null | undefined; notification_users?: NotificationUsers[] | null | undefined; notification_users_error?: GenericError | null | undefined; }' is not assignable to type 'ReferralNotificationUsersState'.
      return {
        ...state,
        notification_config_users: action.payload,
        current_state: ReferralCurrentState.IDLE,
      };
    }
    case NOTIFICATION_CONFIG_USERS_LOADING:
      // @ts-expect-error - TS2322 - Type '{ current_state: "fetchingNotificationConfigUsers"; notification_config_users?: NotificationUsers[] | null | undefined; notification_config_users_error?: GenericError | null | undefined; notification_users?: NotificationUsers[] | null | undefined; notification_users_error?: GenericError | null | undefined; }' is not assignable to type 'ReferralNotificationUsersState'.
      return {
        ...state,
        current_state: ReferralCurrentState.FETCHING_NOTIFICATION_CONFIG_USER,
      };

    case NOTIFICATION_CONFIG_USERS_ERROR:
      // @ts-expect-error - TS2322 - Type '{ notification_config_users_error: GenericError | null | undefined; current_state: "idle"; notification_config_users?: NotificationUsers[] | null | undefined; notification_users?: NotificationUsers[] | null | undefined; notification_users_error?: GenericError | null | undefined; }' is not assignable to type 'ReferralNotificationUsersState'.
      return {
        ...state,
        notification_config_users_error: action.payload,
        current_state: ReferralCurrentState.IDLE,
      };

    default:
      // @ts-expect-error - TS2322 - Type 'ReferralNotificationUsersState | null' is not assignable to type 'ReferralNotificationUsersState'.
      return state;
  }
};
